import { Route, Timer, Fuel, Ticket } from "lucide-react";
import { formatDuration, routeCosts } from "@/lib/route";
import { t } from "@/lib/i18n";

const euro0 = (n) => `€ ${Math.round(n)}`;

export const RouteInfo = ({ km, min, testid = "route-info", loading }) => {
  if (loading) return <div data-testid={`${testid}-loading`} className="text-sm text-[#94A3B8]">{t("Calcolo percorso…")}</div>;
  if (!km) return null;
  const { toll, fuel } = routeCosts(km);
  return (
    <div data-testid={testid} className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs sm:text-sm text-[#CBD5E1]">
      <span className="flex items-center gap-1 font-bold text-white"><Route size={14} className="text-[#10B981]" /> {km.toLocaleString()} km</span>
      {min ? <span className="flex items-center gap-1"><Timer size={14} /> {formatDuration(min)}</span> : null}
      {toll > 0 && <span className="flex items-center gap-1"><Ticket size={14} /> {t("Pedaggio")} ~{euro0(toll)}</span>}
      <span className="flex items-center gap-1"><Fuel size={14} /> {t("Carburante")} ~{euro0(fuel)}</span>
      <span className="text-[10px] uppercase tracking-wide text-[#64748B]">{t("stima")}</span>
    </div>
  );
};
